import { useEffect } from 'react';

import env from 'environment';

const {
  PLATFORM_URL,
} = env;

const useCollisionTooltips = () => {
  useEffect(() => {
    (async () => {
      const { default: initTooltips } = await fetch(`${PLATFORM_URL}/asset_path/tooltips.js`)
        .then((response) => response.text())
        .then((code) => (0, eval)(code));

      initTooltips({
        collisionUrl: PLATFORM_URL,
        fullUrlPage: true,
      });
    })();

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = `${PLATFORM_URL}/asset_path/front/tooltips.css`;
    document.body.appendChild(link);
  }, [false]);
};

export default useCollisionTooltips;



// WEBPACK FOOTER //
// ./app/containers/App/useCollisionTooltips.js